
import { NavigationButtons } from '@/commons/types'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { RouterUtils } from '@/commons/utils/router'

@Component
export default class AppNavigation extends Vue {
    @Prop() navigationButtons!: Array<NavigationButtons>

    async navigate (path: string): Promise<void> {
        await this.$router.push(path, RouterUtils.setFocusToBody)
    }
}
